import React from 'react';
import {Col, Row, Container} from "react-bootstrap";

export default function Home() {

    return (
        <>
            <div id="home">
                <Container fluid className="px-0">
                    <Row>
                        <Col xl={7}>
                            <div className="card-container">
                                <div className="card-animated"></div>
                            </div>
                        </Col>
                        <Col xl={5} className="pe-xl-0 ps-xl-3">
                            <h3>Le Dashboard qui vous dit tout sur la visibilité des artistes</h3>
                            <p>Découvrez l'outil de visualisation de visibilité, pensé par les équipes de la Chaire PcEn et développé en collaboration avec Marec M'Barki. Utilisez le champ de recherche pour rechercher votre artiste favori et afficher les informations concernant sa visibilité sur Spotify, ainsi que les autres artistes écoutés par ses fans !</p>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}